import { render } from "./AdminCompanyLineView.vue?vue&type=template&id=35c354e3&scoped=true"
import script from "./AdminCompanyLineView.vue?vue&type=script&lang=js"
export * from "./AdminCompanyLineView.vue?vue&type=script&lang=js"

import "./AdminCompanyLineView.vue?vue&type=style&index=0&id=35c354e3&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c354e3"]])

export default __exports__